module.exports = __webpack_public_path__ + "img/BIT_white21.573724a6.jpg";